import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
// ui
import { ListItemIcon, Menu, MenuItem, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import PrintIcon from '@material-ui/icons/Print';
import saga from '../../../../saga';
import connectSaga from '../../../../../../utils/saga';
import { dispatchesActions } from '../../../../reducer';
import { selectState, actionProps } from '../../../../../../utils/reduxActions';
// utils
import { truthty, clone } from '../../../../../../utils/functions';

function ItemMenu(props) {
  const { t } = useTranslation();
  const {
    cDispatch: dispatch,
    handleClick,
    handleClose,
    toggleDelete,
    toggleEdit,
    printFnc,
    anchorEl,
    canPrint = true,
    canDelete = true,
  } = props;

  const hasVisibleActions = canPrint || canDelete;

  return (
    <>
      {hasVisibleActions && (
        <IconButton onClick={handleClick} data-id={dispatch.id}>
          <MoreVertIcon data-id={dispatch.id} />
        </IconButton>
      )}
      {hasVisibleActions && truthty(anchorEl) && Number(anchorEl.dataset.id) === dispatch.id && (
        <Menu anchorEl={anchorEl} keepMounted open={truthty(anchorEl)} onClose={handleClose}>
          {canPrint && (
            <MenuItem onClick={printFnc}>
              <ListItemIcon>
                <PrintIcon />
              </ListItemIcon>
              {t('Print paks')}
            </MenuItem>
          )}
          {canDelete && (
            <MenuItem onClick={toggleDelete}>
              <ListItemIcon>
                <DeleteIcon />
              </ListItemIcon>
              {t('Delete')}
            </MenuItem>
          )}
        </Menu>
      )}
    </>
  );
}

export default ItemMenu;
